import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetStoreSaleOrderByOrderNoV2 = (params: any) =>
    request({
        url: ApiURL.Query.GetStoreSaleOrderByOrderNoV2,
        method: RequestType.GET,
        params: params,
    });

const GetStoreDispatchFileForReturn = (params: any) =>
    request({
        url: ApiURL.Query.GetStoreDispatchFileForReturn,
        method: RequestType.POST,
        params: params,
        responseType: 'blob',
    });
const GetStoreInvoiceFile = (params: any) =>
    request({
        url: ApiURL.Query.GetStoreInvoiceFile,
        method: RequestType.GET,
        params: params,
        responseType: 'blob',
    });

const GetDocumentHeaderOfInvoiceByOrderId = (params: any) =>
    request({
        url: ApiURL.Query.GetDocumentHeaderOfInvoiceByOrderId,
        method: RequestType.GET,
        params: params,
    });
const GetMPReturnCargoLabel = (params: any) =>
    request({
        url: ApiURL.Query.GetMPReturnCargoLabel,
        method: RequestType.GET,
        params: params,
        responseType: 'blob',
    });
const GetCargoLabelPdf = (params: any) =>
    request({
        url: ApiURL.Query.GetCargoLabelPdf,
        method: RequestType.GET,
        params: params,
        responseType: 'blob',
    });

const StoreQuery = {
    GetStoreInvoiceFile,
    GetStoreSaleOrderByOrderNoV2,
    GetDocumentHeaderOfInvoiceByOrderId,
    GetMPReturnCargoLabel,
    GetCargoLabelPdf,
    GetStoreDispatchFileForReturn,
};

export default StoreQuery;
